import React, { useState ,useEffect} from 'react';
import { Box } from '@mui/material';
import { useDispatch,useSelector  } from 'react-redux';
import { restoreAuth } from './redux/slices/authSlice';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate ,useLocation} from 'react-router-dom';
import LoginForm from './Components/LoginForm';
import RegisterForm from './Components/RegisterForm';
import AdminDashboard from './Components/AdminDashboard';
import ProtectedRoute from "./Components/ProtectedRoute";
import UserDashboard from './Components/UserDashboard';
import UnauthorizedPage from './Components/UnauthorizedPage';
import CartPage from './Components/CartPage';
import ForgotPassword from './Components/ForgotPassword';
import OTPVerify from './Components/OTPVerify';
const AuthWrapper = () => {
  const [isLogin, setIsLogin] = useState(false);
  const navigate = useNavigate();
    const location = useLocation();
  const page = location.state?.page || "";
    useEffect(() => {
      if(page === "forget"){
        setIsLogin(true)
      }
    }, [page, navigate]);
 const handleLogin = () => {
    // ? Disable logout guard if active (so back works normally)
    if (window.__logoutGuardActive) {
      window.removeEventListener("popstate", window.__logoutGuardListener);
      window.__logoutGuardActive = false;
      window.__logoutGuardListener = null;
    }

    // ? Replace /auth in history to prevent going back to it right after login
    navigate("/admin-dashboard", { replace: true });
  };

  const handleRegister = () => {
    setIsLogin(true); // Go back to login form
  };

  const toggle = () => setIsLogin(prev => !prev);

  return (
    <Box
      sx={{
        //minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage:
          `linear-gradient(to bottom right, rgba(245, 188, 188, 0.85), rgba(236, 117, 109, 0.8)), url('/images/auth-bg.jpg')`,
        backgroundSize: 'cover',
        // p: 2,
      }}
    >
      {isLogin ? (
        <LoginForm onLogin={handleLogin} onSwitchToRegister={toggle} />
      ) : (
        <RegisterForm onRegister={handleRegister} onSwitchToLogin={toggle} />
      )}
    </Box>
  );
};

const App = () => {
   const dispatch = useDispatch();
    const navigate = useNavigate();
  const location = useLocation();
   const { authLoaded } = useSelector((state) => state.auth);
  useEffect(() => {
    const stored = localStorage.getItem('auth');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (parsed.token) {
          dispatch(restoreAuth(parsed));
        } else {
          dispatch(restoreAuth(null));
        }
      } catch {
        dispatch(restoreAuth(null));
      }
    } else {
      dispatch(restoreAuth(null));
    }
  }, [dispatch]);
   // ?? Remove previous global listener if any (safety cleanup)
  useEffect(() => {
    if (window.__logoutGuardActive && window.__logoutGuardListener) {
      window.removeEventListener("popstate", window.__logoutGuardListener);
      window.__logoutGuardActive = false;
      window.__logoutGuardListener = null;
    }
  }, []);
    if (!authLoaded) return <div>Loading...</div>;

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/auth" replace />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
       <Route path="/otp-verify" element={<OTPVerify />} />
      <Route path="/auth" element={<AuthWrapper />} />
       {/* Admin Dashboard Route */}
      <Route path="/admin-dashboard/*" element={
        <ProtectedRoute allowedRoles={["admin"]}>
            <AdminDashboard />
         </ProtectedRoute>
      } />
       {/* User Dashboard Route */}
           <Route
        path="/user-dashboard/*"
        element={
          <ProtectedRoute allowedRoles={["user"]}>
            <UserDashboard />
          </ProtectedRoute>
        }
      />
       {/* <Route
        path="/user-dashboard/cart/*"
        element={
          <ProtectedRoute allowedRoles={["user"]}>
            <CartPage />
          </ProtectedRoute>
        }
      /> */}
      {/* Unauthorized or fallback route */}
       <Route path="/unauthorized" element={<UnauthorizedPage/>} />
      <Route path="*" element={<Navigate to="/auth" replace />} />
   
    </Routes>

);
}
export default App;
